import { Routes, Route } from 'react-router-dom'

import Home from '../pages/Home'
import BoxList from '../pages/BoxList'
import BoxDetail from '../pages/BoxDetail'
import CreateBox from '../pages/CreateBox'
import AcceptInvitation from '../pages/AcceptInvitation'
import Login from '../pages/Login'
import SignUp from '../pages/SignUp'
import ForgotPassword from '../pages/ForgotPassword'
import MyContributions from '../pages/MyContributions'
import HowTo from '../pages/HowTo'
import Feedback from '../pages/Feedback'
import Versions from '../pages/Versions'
import Rules from '../pages/Rules'
import ProtectedRoute from '../components/ProtectedRoute'
import HomeRedirect from '../components/HomeRedirect'

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HomeRedirect />} />
      <Route path="/how-to" element={<HowTo />} />
      <Route path="/rules" element={<Rules />} />
      <Route path="/versions" element={<Versions />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route
        path="/invitations/:id"
        element={
          <ProtectedRoute>
            <AcceptInvitation />
          </ProtectedRoute>
        }
      />
      <Route path="/home" element={<Home />} />
      <Route
        path="/boxes"
        element={
          <ProtectedRoute>
            <BoxList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/boxes/new"
        element={
          <ProtectedRoute>
            <CreateBox />
          </ProtectedRoute>
        }
      />
      <Route
        path="/boxes/:id"
        element={
          <ProtectedRoute>
            <BoxDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path="/activity"
        element={
          <ProtectedRoute>
            <MyContributions />
          </ProtectedRoute>
        }
      />
      <Route
        path="/feedback"
        element={
          <ProtectedRoute>
            <Feedback />
          </ProtectedRoute>
        }
      />
    </Routes>
  )
}
